import React, { FC } from 'react'
import { UseFormMethods } from 'react-hook-form'
import moment from 'moment'
import ControlledDatePicker from 'transfix-form/components/ControlledDatePicker'
import { Box, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { FORMATS } from 'constants/datetime'
import ControlledTimeInput from './ControlledTimeInput'

interface IControlledDateTimeInputProps
  extends Partial<Pick<UseFormMethods, 'control' | 'errors'>> {
  /**
   * @default 'dueDate'
   */
  dateName?: string
  timeName?: string
  /**
   * @default null
   */
  defaultValue?: string | null
}

const useControlledDateTimeInputStyles = makeStyles(() => ({
  datePicker: {
    '& .MuiInputBase-root': {
      height: '40px',
    },
    '& .MuiOutlinedInput-input': {
      paddingTop: 0,
      paddingBottom: 0,
      color: `${brandColors.coolGray8}!important`,
    },
  },
}))

/**
 * This component will use a single Date input value and split it
 * Into 2 different Controlled inputs, One for Date and the other for Time
 * @example <ControlledDateTimeInput defaultValue='2021-06-30T15:49:20.475Z' control={control} errors={errors} />
 */
const ControlledDateTimeInput: FC<IControlledDateTimeInputProps> = ({
  control,
  dateName = 'dueDate',
  defaultValue = null,
  errors,
  timeName,
}) => {
  const classes = useControlledDateTimeInputStyles()
  const defaultTimeValue = defaultValue
    ? moment(defaultValue).format(FORMATS.timeFormat)
    : undefined

  return (
    <Box display='flex' data-test='controlled-date-time-input'>
      <Box width='150px'>
        <label htmlFor='calendar' className='label'>
          Due Date
        </label>
        <ControlledDatePicker
          name={dateName}
          control={control}
          defaultValue={defaultValue}
          DatePickerProps={{
            placeholder: 'Due Date',
            className: classes.datePicker,
            dataTest: 'due-date-input',
          }}
        />
      </Box>
      <ControlledTimeInput
        name={timeName}
        data-test='due-time'
        control={control}
        value={defaultTimeValue}
        errors={errors}
      />
    </Box>
  )
}

export default ControlledDateTimeInput
